import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrRedirect } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrRedirect = (redirect?: PqrRedirect) => {
    const formik = useFormik({
        initialValues: {
            area1: '',
            person1: '',
            email1: '',
            area2: '',
            person2: '',
            email2: '',
            area3: '',
            person3: '',
            email3: '',
            redirectPqr: false,
            generateAlert: false,
            addAnnex: false,
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            area1: useGetNameOrValue(redirect?.area1 || ''),
            person1: useGetNameOrValue(redirect?.person1 || ''),
            email1: redirect?.email1 || '',
            area2: useGetNameOrValue(redirect?.area2 || ''),
            person2: useGetNameOrValue(redirect?.person2 || ''),
            email2: redirect?.email2 || '',
            area3: useGetNameOrValue(redirect?.area3 || ''),
            person3: useGetNameOrValue(redirect?.person3 || ''),
            email3: redirect?.email3 || '',
            redirectPqr: redirect?.redirectPqr || false,
            generateAlert: redirect?.generateAlert || false,
            addAnnex: redirect?.addAnnex || false,
        });
    }, [redirect]);

    return {
        formik,
    };
};
